export default "__VITE_ASSET__DQWrW0LH__"